import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login-guard.service';
import { AuthGuard } from './auth-guard.service';
var routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
    { path: '', loadChildren: 'app/dashboard/index.module#DashboardModule', canActivate: [AuthGuard] },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app-routing.module.ts.pre-build-optimizer.js